import { render, staticRenderFns } from "./LottoButton.vue?vue&type=template&id=b9e7c04c&scoped=true&"
import script from "./LottoButton.vue?vue&type=script&lang=js&"
export * from "./LottoButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9e7c04c",
  null
  
)

export default component.exports